import { Observable } from 'rxjs';

import { IDynamicItemValue } from './dynamic-items.interface';

export enum LogicOperator {
  AND = 'AND',
  OR = 'OR',
  IN = 'IN',
  NOT = 'NOT',
  GT = 'GT',
  LT = 'LT',
  EQ = 'EQ',
  GTEQ = 'GTEQ',
  LTEQ = 'LTEQ',
}
export type OperationValues = [
  IDynamicItemValue | Observable<unknown>,
  IDynamicItemValue | Observable<unknown>,
];
/*
  - case: [LogicOperator, OperationValues]
    e.g.: ['EQ', [2,3]]
    e.g.: ['EQ', [{ provider: 'SomeProvider1', property: 'someProperty1' }, { provider: 'SomeProvider1', property: 'someProperty1' }]]
  - case: [LogicOperator, [Operation, Operation]]
    e.g.: ['AND', [['LT', [2,3]], ['GT', [3,2]]]]
  - case: [LogicOperator, Operation]
    e.g.: ['NOT', ['EQ', [2,3]]]
*/
export type Operation = [
  keyof typeof LogicOperator,
  // tslint:disable-next-line:max-union-size
  OperationValues | [Operation, Operation] | Operation,
];

export function isOperation(value: unknown): value is Operation {
  if (!Array.isArray(value)) {
    return false;
  }

  const [a] = value;

  if (isLogicOperator(a)) {
    return true;
  }

  return false;
}

export function isLogicOperator(value: unknown): value is LogicOperator {
  if (typeof value !== 'string') {
    return false;
  }

  return Object.values(LogicOperator).indexOf(value as LogicOperator) !== -1;
}
